// extracted by mini-css-extract-plugin
export default {"docContainer":"Docs_docContainer__rZFVb","docContent":"Docs_docContent__a7Op8"};